__webpack_require__.p = "/for-fun-js/";